export default __webpack_public_path__ + "media/assets/fonts/roboto-v20-latin-italic-52e23852fb87bb7a6d13cf19afb73a66.ttf";